import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { ICardCredentials } from 'src/app/user-management/user-management-interfaces';

@Component({
  selector: 'app-view-user-physical-credentials',
  templateUrl: './view-user-physical-credentials.component.html',
  styleUrls: ['./view-user-physical-credentials.component.scss'],
})
export class ViewUserPhysicalCredentialsComponent {
  @Input() selectedCredentials?: ICardCredentials;
  @Input() step?: number;
  @Output() stepChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;

  constructor() {}

  viewCardAccess(): void {
    this.stepChange.emit((this.step = 3));
  }
}
